import { generateRequest } from '.';
import { compact } from '../../lib/utils';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  MemberInfo: {
    MemberInfoPending: 'MemberInfo_PENDING',
    MemberInfoCompleted: 'MemberInfo_FULFILLED',
    MemberInfoFailed: 'MemberInfo_FAILED',
    MemberUploadImagePending: 'MemberUploadImage_PENDING',
    MemberUploadImageCompleted: 'MemberUploadImage_FULFILLED',
    MemberUploadImageFailed: 'MemberUploadImage_FAILED',
    MemberContestInfoPending: 'MemberContestInfo_PENDING',
    MemberContestInfoCompleted: 'MemberContestInfo_FULFILLED',
    MemberContestInfoFailed: 'MemberContestInfo_FAILED',
  },
  Membername: {
    UpdatePending: 'MembernameUpdate_PENDING',
    UpdateCompleted: 'MembernameUpdate_FULFILLED',
    UpdateFailed: 'MembernameUpdate_FAILED',
    UpdateReset: 'MembernameUpdate_Reset',
    UpdateCancelled: 'MembernameUpdate_Cancelled',
    UpdateFinished: 'MembernameUpdate_Finished',
  },
};

// TODO: Remove in favor of graphql
export const getMemberProfileById = queryParams => generateRequest({
  endpoint: `/assets-v2/api/member?${toQueryString(compact(queryParams))}`,
  types: [
    Action.MemberInfo.MemberInfoPending,
    Action.MemberInfo.MemberInfoCompleted,
    Action.MemberInfo.MemberInfoFailed,
  ],
});

export const submitMembername = membername => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/member/membername',
  body: { membername },
  types: [
    Action.Membername.UpdatePending,
    Action.Membername.UpdateCompleted,
    Action.Membername.UpdateFailed,
  ],
});

export const resetMembername = () => ({
  type: Action.Membername.UpdateReset,
});

export const cancelMembername = () => ({
  type: Action.Membername.UpdateCancelled,
});

export const finishMembername = () => ({
  type: Action.Membername.UpdateFinished,
});

export const updateProfileImage = img => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/member/updateProfileImage',
  body: {
    newImage: img,
  },
  types: [
    Action.MemberInfo.MemberUploadImagePending,
    Action.MemberInfo.MemberUploadImageCompleted,
    Action.MemberInfo.MemberUploadImageFailed,
  ],
});
